import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CodeInputComponent } from './code-input/code-input.component';
import { EmailVerificationComponent } from './email-verification.component';
import { EmailVerificationDialogComponent } from './email-verification-dialog/email-verification-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';
import { GoCdkPopoverDirective } from '@go-modules/directives/go-cdk-popover/go-cdk-popover.directive';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		A11yModule,
		GoCdkPopoverDirective,
		GoDialogContentDirective
	],
	declarations: [
		CodeInputComponent,
		EmailVerificationComponent,
		EmailVerificationDialogComponent
	],
	exports: [
		CodeInputComponent,
		EmailVerificationComponent,
		EmailVerificationDialogComponent
	]
})
export class EmailVerificationModule {}
